/* eslint-disable complexity */
import { TRelatedBlogs } from '../articles/types'
import { EntityStats, StockDetails } from '@/components/Stocks/Widgets/types'

export const getUSL2TopNav = ({
  stock_details,
  usRelatedBlogs,
  entity_stats,
}: {
  stock_details?: StockDetails
  usRelatedBlogs?: TRelatedBlogs | null
  entity_stats?: EntityStats
}) => {
  const {
    research: entityDetailsResearch,
    analyst_forecast,
    stock_peers,
    mutual_fund_holdings,
    news_items,
    insights_data,
    valuations,
    interest_data = [],
    sp,
    pnl,
    cf,
    returns_calculator,
    institutional_holdings,
    company_details,
  } = stock_details ?? {}

  const { performance } = entity_stats ?? {}
  const { consensus = {} } = analyst_forecast ?? {}

  const { management_team } = company_details ?? {}

  const { infographics, corp_announcements } = entityDetailsResearch ?? {}

  const pnlQuarterly = pnl?.contents?.find(
    el => el?.name?.toLowerCase?.() === 'quarterly',
  )
  const pnlAnnual = pnl?.contents?.find(
    el => el?.name?.toLowerCase?.() === 'annual',
  )

  const cfQuarterly = cf?.contents?.find(
    el => el?.name?.toLowerCase?.() === 'quarterly',
  )
  const cfAnnual = cf?.contents?.find(
    el => el?.name?.toLowerCase?.() === 'annual',
  )

  return [
    { id: 'share-price', label: 'Share Price' },
    !!performance && {
      id: 'performance',
      label: 'Performance',
    },
    !!stock_peers?.length && {
      id: 'fundamentals',
      label: 'Fundamentals',
    },
    !!valuations && {
      id: 'valuation',
      label: 'Valuation',
    },
    !!stock_peers?.length && {
      id: 'peers',
      label: 'Peers',
    },
    !!returns_calculator && {
      id: 'returns-calculator',
      label: 'Returns Calculator',
    },
    consensus?.sentiment && {
      id: 'analyst-recommendation',
      label: 'Analyst Recommendation',
    },
    analyst_forecast && {
      id: 'target-price',
      label: 'Target Price',
    },
    !!interest_data?.length && {
      id: 'sentiment',
      label: 'Sentiment',
    },
    (!!pnlQuarterly || !!pnlAnnual) && {
      id: 'pnl',
      label: 'Profit & Loss',
    },
    (!!cfQuarterly || !!cfAnnual) && {
      id: 'cf',
      label: 'Cash Flow',
    },
    (!!mutual_fund_holdings?.length ||
      !!sp?.contents?.length ||
      !!institutional_holdings?.length) && {
      id: 'shareholding',
      label: 'Shareholding',
    },
    corp_announcements?.heading &&
      !!corp_announcements?.list?.length && {
        id: 'corp-action',
        label: 'Corporate Actions',
      },
    (!!usRelatedBlogs?.length || news_items?.news_timelines) && {
      id: 'blogs-news',
      label: 'Blogs & News',
    },
    (!!insights_data || infographics?.heading) && {
      id: 'insights',
      label: 'Insights',
    },
    (company_details || !!management_team?.rows?.length) && {
      id: 'company-info',
      label: 'Company Info',
    },
    {
      id: 'faqs',
      label: 'FAQs',
    },
  ].filter(Boolean) as { id: string; label: string }[]
}
